import _ from 'lodash';

import worldMap from '../../core/map';
import { LocaleTypeEnum } from '../../../enuns/localeType.enum';
import AreaSharedAfterSalesLayer from './AreaSharedAfterSalesLayer';
import Leaflet from '../Leaflet';
import environment from '../../environment';
import store from '../../../store';
import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../../store/modules/overview-panel/types';

const LayerControls = (name) => require('../../controls').get(name);
const LayerInfo = (name) => require('../../info').get(name);

const name = 'SelectedAreasAfterSales';

class SelectedAreasAfterSalesLayer extends AreaSharedAfterSalesLayer {
    constructor(currentMap) {
        const mapId = currentMap._id;

        const onClick = (feature) => {
            try {
                if (worldMap.getCurrent()._id === mapId && LayerControls(name).getTypeValue() !== LocaleTypeEnum.SetorCensitarioNeocorp) {
                    const status = LayerInfo(name).check(feature.properties.Id) ? 'uncheck' : 'check';
                    $(`#SelectedAreasAfterSales-selection-${feature.properties.Id}`).iCheck(status);
                }
            } catch (err) {
                console.log(err);
            }
        };

        const onComplete = () => {
            LayerControls(name).show({
                show: false,
                refresh: true
            });

            if (store.getters[OVERVIEW_PANEL_GET_CURRENT] === name && store.getters[OVERVIEW_PANEL_IS_VISIBLE] && LayerControls(name).getControls(mapId).button.overview.enable) {
                LayerControls(name).toggleOverview();
            }
        };

        const lyr = new Leaflet.D3Layer();

        let idLayerType = (() => {
            try {
                return environment.get('CONFIG.FILTERS.AREAS_TYPES')[_.take(_.keys(environment.get('CONFIG.FILTERS.AREAS_TYPES')), 1)[0]].id;

            } catch (error) {
                return environment.get('TYPE.AUTO');
            }
        })();

        if (mapId === 1 && idLayerType < 0) {
          idLayerType = LayerControls(name).getControls(0).dropdown.list.value;
          const mapSelect = worldMap.get(0);

          const oldZoom = mapSelect.getZoom();
          const newZoom = oldZoom + 0.1;

          // Adjust shape on map after resize to compare map.
          mapSelect.setZoom(newZoom);
          setTimeout(() => {
            mapSelect.setZoom(oldZoom);
          }, 200);
        }

        const options = {
            map: currentMap,
            name,
            filter: {
                location: true
            },
            showAll: false,
            onClick,
            cache: false,
            scaleRange: new Leaflet.ZoomLevel(lyr, { id: idLayerType }),
            done: onComplete,
        };

        super(currentMap, options);
    }
}

export default SelectedAreasAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/SelectedAreasAfterSalesLayer.js